// extracted by mini-css-extract-plugin
module.exports = {"mobileAndTabletErrorMessageHolder":"MobileAndTabletErrorPage_mobileAndTabletErrorMessageHolder__18EN9","errorLogo":"MobileAndTabletErrorPage_errorLogo__Oap6v"};